import { render, staticRenderFns } from "./UpdateSlas.vue?vue&type=template&id=2c0cbb64&"
import script from "./UpdateSlas.vue?vue&type=script&lang=js&"
export * from "./UpdateSlas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports